/* ==========================================================================
   Sprayo CRO — add from the empty cart.

   One bottle of the card's fragrance, straight into the cart, and the drawer
   re-rendered in place so the reader watches their empty cart become a cart.
   The drawer is open when this runs, so it is told not to toggle — the
   theme's renderContents closes an open drawer otherwise.

   Loaded once from snippets/cart-drawer.liquid, outside the part of the
   drawer that gets replaced on every render.
   ========================================================================== */

if (!customElements.get("sprayo-cart-add")) {
  customElements.define(
    "sprayo-cart-add",
    class SprayoCartAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("button");
        if (!this.button) return;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener("click", this.onClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.onClick);
      }

      async onClick(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.classList.contains("is-loading")) return;

        this.button.classList.add("is-loading");
        this.button.setAttribute("aria-busy", "true");
        this.clearError();

        const drawer = document.querySelector("cart-drawer");
        const addUrl = (window.routes && window.routes.cart_add_url) || "/cart/add";

        try {
          const res = await fetch(`${addUrl}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/javascript" },
            body: JSON.stringify({
              items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
              sections: "cart-drawer,cart-icon-bubble",
              sections_url: window.location.pathname,
            }),
          });
          const body = await res.json();

          if (!res.ok || body.status) {
            this.showError(
              body.description || body.message || this.dataset.errorAdd || "Could not add to cart."
            );
            return;
          }

          if (drawer && body.sections) {
            drawer.renderContents({ sections: body.sections }, false);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || "/cart";
            return;
          }

          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "sprayo-cart-add", cartData: body });
          }
        } catch (error) {
          console.error("[sprayo] add from empty cart failed", error);
          this.showError(this.dataset.errorNetwork || "Could not reach the cart. Please try again.");
        } finally {
          if (this.isConnected) {
            this.button.classList.remove("is-loading");
            this.button.removeAttribute("aria-busy");
          }
        }
      }

      showError(message) {
        let el = this.querySelector(".sprayo-cart-empty__error");
        if (!el) {
          el = document.createElement("p");
          el.className = "sprayo-cart-empty__error";
          el.setAttribute("role", "alert");
          this.appendChild(el);
        }
        el.textContent = message;
      }

      clearError() {
        const el = this.querySelector(".sprayo-cart-empty__error");
        if (el) el.remove();
      }
    }
  );
}
